export default "__VITE_ASSET__f0f09c1a__"